import React, { useState, useRef, useEffect } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import "./AddOrgUserModal.css";
import { fetchTariffes } from "../../store/tariffesSlice";
import { useDispatch } from "react-redux";
import { adminInviteUser, submitFeedback } from "../../store/usersSlice";
import toast from "react-hot-toast";

const AddOrgUserModal = ({ isOpen, onClose, onSubmit, chosenTariff }) => {
  const [userEmail, setUserEmail] = useState("");
  const [firstNameValue, setFirstNameValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const modalRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    setIsLoading(false);
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !event.target.className.includes("add-usr-tariff-option")
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  const handleSubmit = () => {
    if (!userEmail || !firstNameValue || isLoading || !chosenTariff) return;
    setIsLoading(true);
    const settings = {
      name: firstNameValue,
      email: userEmail,
      message: `Новый запрос на оформление тарифа для юридического лица.\n\nИмя: ${firstNameValue}\nЭлекронная почта: ${userEmail}\nЗапрошенный тариф: ${chosenTariff.name}`,
    };
    dispatch(submitFeedback({ feedbackData: settings })).then((res) => {
      if (!res.error) {
        setIsLoading(false);
        onSubmit();
      } else {
        setIsLoading(false);
        toast.error("Ошибка отправки! Повторите позже");
      }
    });
  };

  if (!isOpen) return null;

  return (
    <div className="add-usr-modal-overlay">
      <div className="add-org-modal" ref={modalRef}>
        <button
          className="add-org-close-button"
          style={{ transform: "scale(0.7)", right: 14, top: 14 }}
          onClick={onClose}
        />
        <h1
          className="add-org-modal-title"
          style={{ marginBottom: 1, marginTop: 1, fontSize: 22 }}
        >
          {`Оформление тарифа "${(chosenTariff && chosenTariff.name) || ""}" для юр. лица`}
        </h1>
        <span
          className="add-org-modal-title"
          style={{
            fontSize: 14,
            fontWeight: 400,
            marginTop: 10,
            marginBottom: 16,
          }}
        >
          Заполните форму, и мы свяжемся с вами
        </span>
        <div className="add-org-modal-content">
          <input
            className="add-usr-input"
            type="text"
            placeholder="Электронная почта"
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            disabled={isLoading}
            maxLength={64}
          />
          <input
            className="add-usr-input"
            type="text"
            placeholder="ФИО"
            value={firstNameValue}
            onChange={(e) => setFirstNameValue(e.target.value)}
            disabled={isLoading}
            maxLength={64}
          />
        </div>
        <button
          onClick={handleSubmit}
          style={{ marginTop: 0 }}
          className="add-usr-submit-button"
        >
          {isLoading ? "Загрузка..." : "Отправить"}
        </button>
      </div>
    </div>
  );
};

export default AddOrgUserModal;
